import { render, staticRenderFns } from "./DkChips.vue?vue&type=template&id=43a53516&"
import script from "./DkChips.vue?vue&type=script&lang=js&"
export * from "./DkChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports